import Clarity from "@microsoft/clarity";
import { ENVIRONMENT } from "@repo/shared";
import { useEffect } from "react";
import TagManager from "react-gtm-module";

const COOKIEYES_SCRIPT_URL =
  "https://cdn-cookieyes.com/client_data/15f6c3e1a13e84b140799ac9/script.js";
const CLARITY_PROJECT_ID = "yk4e2jaofe";

const loadCookieYes = () => {
  if (document.getElementById("cookieyes")) return;

  const script = document.createElement("script");
  script.id = "cookieyes";
  script.src = COOKIEYES_SCRIPT_URL;
  document.head.appendChild(script);
};

const initGtm = () => {
  const existingGtmScript = document.querySelector('script[src*="googletagmanager.com/gtm.js"]');
  if (existingGtmScript) {
    console.log("GTM script already exists, skipping initialization");
    return;
  }

  console.log("Initializing GTM");
  TagManager.initialize({
    gtmId: "GTM-PQFC7JMF",
  });
};

const startHotjar = () => {
  const hotjarScript = document.createElement("script");
  hotjarScript.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:6367692,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
  document.head.appendChild(hotjarScript);
};

export default function Analytics() {
  useEffect(() => {
    if (import.meta.env.VITE_ENVIRONMENT === ENVIRONMENT.PRODUCTION) loadCookieYes();
    if (import.meta.env.VITE_ENVIRONMENT !== ENVIRONMENT.LOCAL) initGtm();
  }, []);

  useEffect(() => {
    if (window.location.origin !== "https://nauka.skumani.pl") return;

    // Hotjar and Clarity record sessions, so they start only once analytics cookies are accepted.
    let isRecordingStarted = false;
    const applyConsent = ({ analytics, advertisement }: Record<string, boolean>) => {
      if (!analytics && !isRecordingStarted) return;

      if (!isRecordingStarted) {
        startHotjar();
        Clarity.init(CLARITY_PROJECT_ID);
        isRecordingStarted = true;
      }

      Clarity.consentV2({
        analytics_Storage: analytics ? "granted" : "denied",
        ad_Storage: advertisement ? "granted" : "denied",
      });
    };

    const consent = window.getCkyConsent?.();
    if (consent) applyConsent(consent.categories);

    const handleBannerLoad = (event: DocumentEventMap["cookieyes_banner_load"]) =>
      applyConsent(event.detail.categories);
    const handleConsentUpdate = (event: DocumentEventMap["cookieyes_consent_update"]) =>
      applyConsent({
        analytics: event.detail.accepted.includes("analytics"),
        advertisement: event.detail.accepted.includes("advertisement"),
      });

    document.addEventListener("cookieyes_banner_load", handleBannerLoad);
    document.addEventListener("cookieyes_consent_update", handleConsentUpdate);

    return () => {
      document.removeEventListener("cookieyes_banner_load", handleBannerLoad);
      document.removeEventListener("cookieyes_consent_update", handleConsentUpdate);
    };
  }, []);

  return null;
}
